import { render, staticRenderFns } from "./AsyncLoading.vue?vue&type=template&id=0a74be1a&"
import script from "./AsyncLoading.vue?vue&type=script&lang=js&"
export * from "./AsyncLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports